var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"main-navigation"},[_c('div',{staticClass:"item"},_vm._l(((_vm.isAdmin ? _vm.adminLinks : _vm.links)),function({ key, link }){return _c('router-link',{key:key,attrs:{"to":link,"tag":"span"}},[_vm._v("\n      "+_vm._s(_vm.$t(key))+"\n    ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }